
import { DeviceService, UnitcodeService } from '@gtpl/shared-services/masters';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { ForkLiftJobService } from '@gtpl/shared-services/warehouse-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { TemperatureLog } from './entity/temperature-log.entity';
import { TemperatureLogRepository } from './repository/temperature-log.repository';
import { TemperatureLogAdapter } from './temperature-log.adapter';
import { TemperatureLogController } from './temperature-log.controller';
import { TemperatureLogService } from './temperature-log.service';


@Module({
    imports : [
        TypeOrmModule.forFeature([TemperatureLogRepository])
    ],
    controllers:[TemperatureLogController],
    providers:[TemperatureLogService,ApplicationExceptionHandler,TemperatureLogAdapter,WhatsAppNotificationService,ForkLiftJobService, DeviceService, UnitcodeService],
})
export class TemperatureLogModule {}